import React, { useState, useEffect } from 'react';
import { Dropdown, Space } from 'antd';
import AppButton from '@nxsys/components/AppButton';
import { StyledModal } from './index.styled';
import { CloseOutlined } from '@ant-design/icons';

type AppDrawerContainerProps = {
  isOpen: boolean;
  title: string | React.ReactNode;
  width?: number | string;
  actions?: {
    name: string;
    icon?: React.ReactNode;
    className?: string;
    variant?: 'text' | 'outlined' | 'dashed' | 'link' | 'solid' | 'filled';
    buttonType?: 'link' | 'default' | 'primary' | 'dashed' | 'text' | undefined;
    onClick: () => void;
    disabled?: boolean;
    iconPosition?: 'start' | 'end';
    loading?: boolean;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    actionType?: 'button' | 'dropdown';
    menu?: any;
  }[];
  toggle: () => void;
  children: React.ReactNode;
  isNoHorizontalPadding?: boolean;
  className?: string;
  wrapClassName?: string;
  hiddenFooter?: boolean;
  minHeight?: string;
  closable?: boolean;
  closeIcon?: React.ReactNode;
  footer?: React.ReactNode;
  noPaddingBody?: boolean;
  titleFullWidth?: boolean;
  destroyOnClose?: boolean;
};

const AppModalContainer: React.FC<AppDrawerContainerProps> = ({
  title,
  isOpen,
  toggle,
  width = 640,
  actions,
  children,
  isNoHorizontalPadding = false,
  className,
  wrapClassName,
  hiddenFooter,
  minHeight,
  closable = true,
  closeIcon = <CloseOutlined />,
  footer,
  noPaddingBody = false,
  titleFullWidth = false,
  destroyOnClose,
}: AppDrawerContainerProps) => {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const onCancel = () => {
    setOpen(false);
    toggle();
  };
  return (
    <StyledModal
      open={open}
      destroyOnClose={destroyOnClose}
      title={title}
      width={width}
      minHeight={minHeight}
      onCancel={onCancel}
      isNoHorizontalPadding={isNoHorizontalPadding}
      footer={
        hiddenFooter
          ? null
          : footer || (
              <Space>
                {actions?.map((action, index) =>
                  action.actionType === 'dropdown' ? (
                    <Dropdown menu={action.menu}>
                      <AppButton
                        key={index}
                        icon={action?.icon}
                        name={action.name}
                        variant={action.variant}
                        className={action.className}
                        type={action.buttonType || 'primary'}
                        onClick={action.onClick}
                        loading={action.loading || false}
                        iconPosition={action.iconPosition || 'start'}
                        disabled={action.disabled || false}
                        rightIcon={action.rightIcon}
                        leftIcon={action.leftIcon}
                      />
                    </Dropdown>
                  ) : (
                    <AppButton
                      key={index}
                      icon={action?.icon}
                      name={action.name}
                      variant={action.variant}
                      className={action.className}
                      type={action.buttonType || 'primary'}
                      onClick={action.onClick}
                      loading={action.loading || false}
                      iconPosition={action.iconPosition || 'start'}
                      disabled={action.disabled || false}
                      rightIcon={action.rightIcon}
                      leftIcon={action.leftIcon}
                    />
                  ),
                )}
              </Space>
            )
      }
      className={className || ''}
      wrapClassName={wrapClassName || ''}
      closable={closable}
      closeIcon={closeIcon}
      noPaddingBody={noPaddingBody}
      titleFullWidth={titleFullWidth}
    >
      {children}
    </StyledModal>
  );
};
export default AppModalContainer;
